import { BaseViewModel } from "@/models/core/BaseViewModel";

export class CityModel extends BaseViewModel {
  id = 0;
  name = "";
}
